import { useState, useEffect, useRef } from "react";

import { api, formatCurrency } from "./pureFunctions";

import {
   MapContainer,
   TileLayer,
   useMap,
   Marker,
   Popup,
   Tooltip,
   SVGOverlay,
   CircleMarker,
   Polygon,
} from "react-leaflet";
import "./styles/karte.css";
import { MapLibreTileLayer } from "./MapLibreTileLayer";
import { Form, Col, Button, Row, Table } from "react-bootstrap";

import L from "leaflet";
import markerA from "./img/marker.webp";

import markerPin from "./img/pinMarker.webp";
import markerCircle from "./img/roundmarker.png";
import GetGeoCoords from "./GetGeoCoords";
import { useConfig } from "./ConfigContext";
import { header } from "./globalVariables";

const tableHeader = [
   { key: "objektnr_extern", value: "Objekt-Nr." },
   { key: "objektBezeichnung", value: "Objektbezeichnung" },
   { key: "kaufpreis", value: "Preis" },
];

export default function LeerstandKarte({
   userObjects,
   terminInfos,
   availableUsers,
   showAllUsers,
   calenderday,
   showAlleTage,
   setSelectedTermin,
   selectedTermin,
   terminArten,
   centerPin,
   suedPolygon,
}) {
   const config = useConfig();
   const [estateData, setEstateData] = useState();
   const [selectedEstate, setSelectedEstate] = useState();
   const iconA = new L.Icon({
      iconUrl: markerA,
      iconRetinaUrl: markerA,
      popupAnchor: [-0, -0],
      iconSize: [32, 45],
      iconAnchor: [16, 45],
      className: "custommarker",
   });

   const [map, setMap] = useState(null);
   const iconB = new L.Icon({
      iconUrl: markerCircle,
      popupAnchor: [-0, -0],
      iconSize: [16, 16],
   });

   const iconPin = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
   });

   const [searchCoords, setSearchCoords] = useState();

   async function getEstates() {
      let parameters = {
         data: [
            "objektnr_extern",
            config.estate.verkaufsStatus,
            "benutzer",
            "breitengrad",
            "laengengrad",
            "kaufpreis",
            config.estate.objektBezeichnung, //Objektbezeichnung
         ],
         filter: {
            ind_3130_Feld_ObjIndividualCategoryFields361: [
               {
                  op: "LIKE",
                  val: ['%\"leerstehend\"%'],
               },
            ],
            [config.estate.verkaufsStatus]: [
               {
                  op: "IN",
                  val: ["ind_Schl_5021", "ind_Schl_2927", "status2obj_aktiv"], //statusVorlaufOffline: statusVorlaufOnline statusAktiv
               },
            ],
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };

      return await api.post("/api/readEstates", { parameters }, header).then((data) => {
         console.log(data.data);
         return data.data;
      });
   }

   async function getData() {
      let newEstates = await getEstates();
      setEstateData(
         newEstates.map((item) => ({
            ...item.elements,
            id: item.id,
            objektBezeichnung: item.elements[config.estate.objektBezeichnung],
         })),
      );
   }
   useEffect(() => {
      getData();
   }, []);

   useEffect(() => {
      if (map && searchCoords) {
         map.setView([searchCoords.lat, searchCoords.lon], 14);
      }
   }, [map, searchCoords]);

   useEffect(() => {
      if (map && centerPin && centerPin.breitengrad) {
         console.log([parseFloat(centerPin.breitengrad), parseFloat(centerPin.laengengrad)]);

         map.setView([parseFloat(centerPin.breitengrad), parseFloat(centerPin.laengengrad)], 14);
      }
   }, [map, centerPin]);

   const center = [48.069127679996505, 9.78794715586747];
   const standorte = {
      biberach: [48.09982945986149, 9.788116225682414],
      ulm: [48.39759756595353, 9.991208742270867],
      weingarten: [47.80724916089593, 9.636884784540829],
      ravensburg: [47.7813069817177, 9.613369915116529],
   };
   return (
      <div>
         <div className="mapframe" style={{ maxHeight: "50vh" }}>
            <div style={{ position: "absolute", zIndex: 10, margin: "20px" }}>
               <GetGeoCoords searchCoords={searchCoords} setSearchCoords={setSearchCoords} />
            </div>
            <div style={{ position: "absolute", zIndex: 10, right: 0,margin: "40px" }}>
               <span
                  style={{
                     margin: 5,
                     border: "solid 8px #f0f",
                     background: "#6069",
                     color: "#fff",
                     fontWeight: 700,
                     padding: "4px 10px",
                  }}
               >
                  In Vorlauf
               </span>
               <span
                  style={{
                     margin: 5,
                     border: "solid 8px #fc0",
                     background: "#6309",
                     color: "#fff",
                     fontWeight: 700,
                     padding: "4px 10px",
                  }}
               >
                  Aktiv im Verkauf
               </span>
            </div>
            <MapContainer
               center={center ? center : [47.807276048680215, 9.63688394923563]}
               zoom={10.1}
               zoomSnap={0.1}
               wheelPxPerZoomLevel={160}
               zoomControl={false}
               ref={setMap}
               scrollWheelZoom={true} /*  attributionControl={false} */
            >
               {/* <MapLibreTileLayer
                  url="https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json"
               /> */}
               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               {Object.keys(standorte).map((item) => (
                  <Marker icon={iconA} position={standorte[item]}></Marker>
               ))}

               {estateData?.map((item) => {
                  return (
                     <>
                        <Marker
                           eventHandlers={{
                              click: () => {
                                 setSelectedEstate(item.id);
                              },
                           }}
                           icon={createColoredIcon(
                              item?.[config.estate.verkaufsStatus] === "status2obj_aktiv" ? "#fc0" : "#f0f",
                           )}
                           /* icon={iconB} */ position={[item.breitengrad, item.laengengrad]}
                        >
                           <Popup offset={[0, -7]}>
                              <div>
                                 <h3>{item?.objektnr_extern}</h3>
                                 {item?.[config.estate.objektBezeichnung]}
                                 <ul>
                                    <li>{formatCurrency(item?.kaufpreis)}</li>
                                    <li>
                                       <a target="_blank" href={"/datenblatt?estateid=" + item.id}>
                                          zum Datenblatt
                                       </a>
                                    </li>
                                 </ul>
                              </div>
                           </Popup>
                        </Marker>
                     </>
                  );
               })}

               {searchCoords && <Marker icon={iconB} position={[searchCoords.lat, searchCoords.lon]}></Marker>}
            </MapContainer>
         </div>
         {estateData && (
            <div className="mx-3 mt-3" style={{ maxHeight: "40vh", overflow: "auto" }}>
               <Table striped  bordered hover /* responsive */>
                  <thead style={{ position: "sticky", top: 0 }}>
                     <tr style={{}}>
                        <th style={{ border: "none", position: "sticky", top: 0 }}> </th>
                        {tableHeader.map((item) => {
                           return (
                              <th
                                 style={{
                                    position: "sticky",
                                    top: 0,
                                 }}
                              >
                                 {item.value}
                              </th>
                           );
                        })}
                        <th style={{ position: "sticky", top: 0 }}> </th>
                     </tr>
                  </thead>
                  <tbody>
                     {estateData.map((zeile, index) => (
                        <tr key={index}>
                           <td
                              className="text-center"
                              style={{
                                 cursor: "pointer",
                                 borderRadius: "100px",
                                 border: "none",
                                 ...(selectedEstate === zeile.id
                                    ? { background: "#0aa", color: "#fff" }
                                    : { background: "#ddd" }),
                              }}
                              onClick={() => {
                                 setSelectedEstate(zeile.id)
                                 setSearchCoords({ lat: zeile.breitengrad, lon: zeile.laengengrad });
                              }}
                           >
                              {index + 1}
                           </td>
                           {tableHeader.map((item) => {
                              let columnText;

                              if (item.key === "einkaeufer")
                                 columnText =
                                    zeile[item.key] && (users?.userObject?.[zeile[item.key]]?.Name ?? zeile[item.key]);
                              else if (item.key === "verkaufsstatus") {
                                 columnText =
                                    oOFields?.estate?.status2?.permittedvalues[zeile[item.key]] ?? zeile[item.key];
                              } else if (item.key === "benutzer")
                                 columnText =
                                    zeile[item.key] && (users?.userObject?.[zeile[item.key]]?.Name ?? zeile[item.key]);
                              else if (item.key === "verkauftFur") columnText = formatCurrency(zeile[item.key]);
                              else {
                                 columnText = zeile[item.key];
                              }
                              return <td>{columnText}</td>;
                           })}
                           <td className="text-center">
                              <a
                                 title="zur Onlinestellungskachel"
                                 href={`/datenblatt?estateid=${zeile.estateId}`}
                                 target="_blank"
                              >
                                 zum Datenblatt
                              </a>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </Table>
            </div>
         )}
      </div>
   );
}

const createColoredIcon = (color) => {
   return L.divIcon({
      className: "custom-marker",
      html: `<div style="background-color: ${color}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
      iconSize: [20, 20],
      iconAnchor: [10, 10],
   });
};
